import { getConfig } from '@cian/config/browser';
import { setRequestContentType } from '../../../shared/internal/HTTP/utils/setRequestContentType.mjs';
import { Headers } from '../../../shared/internal/HTTPRequestConfig/Headers.mjs';
import { HTTPRequestConfig } from '../../../shared/internal/HTTPRequestConfig/HTTPRequestConfig.mjs';
import { convertRequestConfig } from '../../../shared/internal/HttpApi/convertRequestConfig.mjs';
import { Context } from '../Context/Context.mjs';
import { FetchRequest } from '../HTTP/FetchRequest.mjs';
import { Request } from '../HTTP/Request.mjs';
import { createURL } from '../URI/URL.mjs';

class HttpApi {
    hooksFactories = [];
    constructor(params) {
        this.circuitBreakerHash = params.circuitBreakerHash;
        this.assertStatusCode = params.assertStatusCode;
    }
    addHook(factory) {
        this.hooksFactories.push(factory);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async fetch(model, fetchConfig) {
        const uri = createURL({
            model,
            subdomain: fetchConfig?.subdomain,
            transformBodyToLegacyString: fetchConfig?.transformBodyToLegacyString,
        });
        const headers = new Headers(fetchConfig?.requestConfig?.headers || {});
        const requestConfig = new HTTPRequestConfig({
            model,
            transformBodyToLegacyString: fetchConfig?.transformBodyToLegacyString,
            bodyAsEncodeString: fetchConfig?.bodyAsEncodeString,
            headers,
            url: uri,
            withCredentials: fetchConfig?.requestConfig?.withCredentials,
        });
        const config = getConfig().attach({
            context: {
                api_request_path: model.pathApi,
                api_request_base_url_key: model.microserviceName,
            },
        });
        const context = new Context({
            userConfig: fetchConfig?.ecnhancersConfig,
            assertStatusCode: this.assertStatusCode,
            model,
            config,
            requestedServerName: model.microserviceName,
            cancellationToken: fetchConfig?.cancellationToken,
            requestConfig,
            pathSimplified: fetchConfig?.pathSimplified,
        });
        const response = await this.sendRequest(requestConfig, context);
        return {
            headers: response.responseHeaders.toArray(),
            response: response.responseBody,
            statusCode: response.responseStatusCode,
        };
    }
    async httpRequest(request, httpApiConfig) {
        const headers = new Headers(request.headers || {});
        const internalRequestConfig = convertRequestConfig(request, headers);
        const requestHash = this.circuitBreakerHash && this.circuitBreakerHash(request);
        const config = getConfig().attach({
            context: {
                api_request_path: request.uri.path,
                api_request_base_url_key: request.uri.host,
            },
        });
        const context = new Context({
            userConfig: httpApiConfig,
            requestHash,
            config,
            assertStatusCode: this.assertStatusCode,
            requestedServerName: internalRequestConfig.url.host,
            cancellationToken: httpApiConfig?.cancellationToken,
            requestConfig: internalRequestConfig,
            pathSimplified: httpApiConfig?.pathSimplified,
        });
        return (await this.sendRequest(internalRequestConfig, context, 'string')).complete();
    }
    async sendRequest(requestConfig, context, responseType) {
        const hooks = this.hooksFactories.map(factory => factory({ context, requestConfig }));
        /** @deprecated В следующем мажоре Content-Type должен устанавливаться всегда, без возможности управления */
        if (context.legacyRequestContentTypeEnabled) {
            setRequestContentType(requestConfig.headers, requestConfig.requestType);
        }
        try {
            const request = context.requestType === 'fetch'
                ? new FetchRequest({
                    requestConfig: requestConfig,
                    timeout: context.timeout,
                    requestServerName: context.requestedServerName,
                    responseType,
                })
                : new Request({
                    requestConfig: requestConfig,
                    timeout: context.timeout,
                    requestServerName: context.requestedServerName,
                    responseType,
                });
            hooks.forEach(hook => hook.onRequest(request));
            const response = await request.send();
            await response.compileBody();
            hooks.forEach(hook => hook.onResponse(response));
            return response;
        }
        catch (error) {
            hooks.forEach(hook => hook.onError(error));
            throw error;
        }
    }
}

export { HttpApi };
//# sourceMappingURL=HttpApi.mjs.map
